import dayjs from 'dayjs';

import styles from './styles.module.scss';
import { DateLlFormat } from '../../constants/data';
import { getCropName } from '../../utils/crops';

const MapMarkerField = ({ t, fieldName, text, date }) => {
  return (
    <div className={styles.mapMarkerField}>
      {fieldName && <div className={styles.mapMarkerFieldText}>{fieldName}</div>}
      {text && <div className={styles.mapMarkerFieldTitle}>{getCropName({ t, id: text })}</div>}
      {date && <time className={styles.mapMarkerFieldDate}>{dayjs(date).format(DateLlFormat)}</time>}
    </div>
  );
};

export default MapMarkerField;
